<template>
  <div>
    <div class="header">
      <div class="container">
        <div class="pull-left">
          <complete-logo style="float: left;margin-right: 40px;" />
          <router-link class="menu" :class="page_type === 'index' ? 'select' : ''" :to="{ name: 'Index' }">
            首页
          </router-link>
          <router-link class="menu" :class="page_type === 'tutor' ? 'select' : ''" :to="{ name: 'TutorList' }">
            找家教
          </router-link>
          <router-link class="menu" :class="page_type === 'reveal' ? 'select' : ''" :to="{ name: 'RevealList' }">
            教员风采
          </router-link>
          <router-link class="menu" :class="page_type === 'forum' ? 'select' : ''" :to="{ name: 'ForumList' }">
            家教论坛
          </router-link>
          <router-link class="menu" :class="page_type === 'helps' ? 'select' : ''"
            :to="{ name: 'HeplsCategory', params: { id: 5 } }">
            帮助中心
          </router-link>
          <router-link class="menu" :class="page_type === 'announce' ? 'select' : ''" :to="{ name: 'NewsList' }">
            新闻公告
          </router-link>
          <router-link v-if="accountType == 'teacher'" class="menu" :class="page_type === 'teacher' ? 'select' : ''"
            :to="{ name: 'TeacherInfo' }">
            个人中心
          </router-link>
          <router-link v-if="accountType == 'user'" class="menu" :class="page_type === 'user' ? 'select' : ''"
            :to="{ name: 'UserInfo' }">
            个人中心
          </router-link>
        </div>
        <div class="pull-right">
          <a-dropdown v-show="loginStatus" placement="bottomCenter">
            <a class="ant-dropdown-link" @click="e => e.preventDefault()">
              <img class="head-portrait" src="@/assets/test-header.png" alt="">
            </a>
            <a-menu slot="overlay" style="margin-top: 13px;">
              <a-menu-item>
                <a href="javascript:;">
                  <a-icon type="user" /> 账户设置
                </a>
              </a-menu-item>
              <a-menu-item>
                <a href="javascript:;" @click="logout">
                  <a-icon type="logout" /> 退出登录
                </a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
          <router-link v-show="!loginStatus" :to="{ name: 'UserLogin' }">
            登录
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CompleteLogo } from '@/components'
import { mapActions } from 'vuex'

export default {
  name: 'SimpleHeader',
  components: {
    CompleteLogo
  },
  props: {
    page_type: {
      type: String,
      default: 'index'
    }
  },
  data() {
    return {
      accountType: undefined,
      loginStatus: false
    }
  },
  created() {
    this.accountType = this.$store.getters.accountType
    this.nick_name = this.$store.getters.userInfo.nick_name ? this.$store.getters.userInfo.nick_name : ''
    if (this.nick_name !== '') {
      this.loginStatus = true
    }
  },
  methods: {
    ...mapActions(['TeacherLogout', 'UserLogout']),
    logout() {
      if (this.accountType === 'user') {
        this.UserLogout().then(() => {
          this.$notification.success({
            message: 'success',
            description: '退出账户成功'
          })
          setTimeout(() => {
            location.reload()
          }, 1000)
        })
      } else {
        this.TeacherLogout().then(() => {
          this.$notification.success({
            message: 'success',
            description: '退出账户成功'
          })
          setTimeout(() => {
            location.reload()
          }, 1000)
        })
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .logo {
    height: 50px;
  }

  .vertical-line {
    content: '';
    height: 14px;
    width: 1px;
    border-radius: 1px;
    float: left;
    margin-top: 13px;
    margin-left: 10px;
    background-color: #eeeeee;
  }

  .header {
    width: 100%;
    height: 60px;
    background-color: #fff;
    box-shadow: 0px 3px 7px 0px rgba(216, 216, 216, 0.3);

    .container {
      width: $container-width;
      height: 60px;
      margin: auto;
      line-height: 60px;
      overflow: hidden;
      padding-right: 10px;
      border-top: 1px solid #eeeeee;

      .pull-left {
        .menu {
          margin-right: 50px;
          color: #333333;
          font-weight: normal;
          font-stretch: normal;
          font-size: 14px;

          &:hover {
            color: $theme-color;
          }
        }

        .select {
          color: $theme-color
        }
      }

      .pull-right {
        margin-right: 20px;

        .head-portrait {
          width: 33px;
          height: 33px;
        }
      }

      .link-jump-title {
        width: 64px;
        height: 16px;
        font-family: MicrosoftYaHeiLight;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #fa750d;
      }
    }
  }
</style>
